"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxWidget = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var styles = __importStar(require("./BoxWidget.css"));
var Box_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Box/Box");
var BoxWidget = function (_a) {
    var children = _a.children, element = _a.element;
    var unpackedChildren = react_1.default.Children.toArray(children);
    var editor = (0, slate_react_1.useSlateStatic)();
    return (react_1.default.createElement(Box_1.BoxWidget, { columns: [unpackedChildren[0], unpackedChildren[1]], centerControls: react_1.default.createElement("div", { className: styles.centerControls, contentEditable: false },
            react_1.default.createElement(kaleidoscope_1.Button, { "data-interactive-zone": true, onClick: function () {
                    slate_1.Editor.withoutNormalizing(editor, function () {
                        var boxNodePath = slate_react_1.ReactEditor.findPath(editor, element);
                        slate_1.Transforms.moveNodes(editor, {
                            at: __spreadArray(__spreadArray([], __read(boxNodePath), false), [0], false),
                            to: __spreadArray(__spreadArray([], __read(boxNodePath), false), [1], false),
                        });
                    });
                } }, "swap")) }));
};
exports.BoxWidget = BoxWidget;
